import { render, staticRenderFns } from "./ModeratorsGrid.vue?vue&type=template&id=332f37a6"
import script from "./ModeratorsGrid.vue?vue&type=script&lang=js"
export * from "./ModeratorsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports